<template>
  <div>

    <b-list-group>
      <b-list-group-item
          v-for="(image, index) in slider"
          :key="image.id"
          class="d-flex justify-content-between align-items-center"
      >
        <div>
          <b-avatar button :src="image.url"></b-avatar>
          {{ image.name }}
        </div>
        <div>
          <b-button variant="outline-primary" @click="showEditImage(image.id)">
            <b-icon-pencil-square/>
          </b-button>
          <b-button variant="outline-danger" class="ml-2" @click="deleteImageFromSlider(image, index)">
            <b-icon-trash/>
          </b-button>
        </div>
      </b-list-group-item>
    </b-list-group>
    <p v-if="slider.length === 0">Es wurden noch keine Bilder hochgeladen.</p>

    <p style="padding-top: 10px;">Hinzufügen:</p>
    <b-input-group class="mt-3">
      <b-form-file
          browse-text="Auswählen"
          multiple
          v-model="files"
          placeholder="Bild auswählen oder hinein ziehen"
          accept="image/*"
      />
      <b-input-group-append>
        <b-button variant="outline-success" @click="uploadFiles">Hochladen</b-button>
      </b-input-group-append>
    </b-input-group>

    <b-modal id="editImage">
      <b>Name:</b>
      <b-input v-model="currentImage.name"></b-input>
      <b-img :src="currentImage.url" fluid-grow alt="Fluid-grow image" style="padding-top: 10px;"></b-img>
      <b>Beschreibung:</b>
      <b-textarea v-model="currentImage.description"/>

      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button size="sm" variant="warning" @click="cancel()" class="text-white">
          Verwerfen
        </b-button>
        <b-button size="sm" variant="success" @click="saveImageDescription()">
          Speichern
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import helpers from './../../helpers'

export default {
  name: "Slider",
  props: {
    slider: Array
  },
  data() {
    return {
      currentImage: {},
      files: null,
    }
  },
  methods: {
    ...mapActions([
      'uploadFile',
      'deleteImage'
    ]),
    showEditImage(id) {
      this.currentImage = this.getCurrentImageDecoupledCopy(id)
      this.$bvModal.show('editImage')
    },
    saveImageDescription() {
      this.$bvModal.hide('editImage')
      let originalImage = this.slider.find(element => element.id === this.currentImage.id)
      originalImage.description = this.currentImage.description
      originalImage.name = this.currentImage.name
    },
    getCurrentImageDecoupledCopy(id) {
      return JSON.parse(JSON.stringify(this.slider.find(element => element.id === id)));
    },
    uploadFiles() {
      if (!this.files) return helpers.handleWarningMessage("Bitte wählen Sie mindestens ein Bild aus.")
      for (const image of this.files) {
        this.uploadFile(image).then(response => {
          this.pushImageToArray(image, response)
        })
      }
    },
    pushImageToArray(image, response) {
      this.slider.push({
        name: image.name,
        description: "",
        url: process.env.VUE_APP_API_URL + response.data,
        id: this.getMaxIdImages() + 1
      })
    },
    getMaxIdImages() {
      return Math.max.apply(Math, this.slider.map(function (image) {
        return image.id;
      }))
    },
    deleteImageFromSlider(image, index) {
      // this.deleteImage(image)
      this.slider.splice(index, 1)
    }
  }
}
</script>

<style scoped>
</style>
